<div class="loading-wrapper">
	<i class="spinner fas fa-spinner"></i>
</div>
